import createApi from './api';

export default class ReportService {
  constructor() {
    this.api = createApi({
      baseUrl: `reports`,
      headers: {
        'Content-Type': 'application/json'
      },
      raw: true
    });
  }

  async generateReport(params) {
    return this.api.post('p4p', params);
  }

  async generateWorkPrediction() {
    return this.api.post('work-prediction', {});
  }

  async getIndividualStats(params) {
    return this.api.post('individual-stats', params);
  }
}
